import styled from 'styled-components'

export const SettingFormsWrapper = styled.div`
  margin-right: 30%;
`
